const CalendarSummary = () => {
    return (
        <div className="h-full p-4 bg-blue-50 rounded shadow">
            <h4>📅 Takvim Özeti</h4>
            <ul>
                <li>09:00 - Ekip Toplantısı</li>
                <li>14:00 - Müşteri Görüşmesi</li>
            </ul>
        </div>
    );
};

export default CalendarSummary;
